import React from "react";
import "../../styles/hero.css"; // Ensure this matches your CSS file path
import hero from "../../assets/hero.png"
import { useNavigate } from "react-router-dom";



const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="pro-hero-wrapper container">
      <div className="pro-hero-card row align-items-center g-0">
        {/* LEFT TEXT SECTION */}
        <div className="col-lg-7 col-md-12 pro-hero-text-col position-relative">
          <h1 className="pro-hero-title">
            Go Global with Your <br />
            Career
          </h1>

          <p className="pro-hero-subtitle">
            Achieve internationally recognized certifications like CPA (US), CMA
            (US), and EA to open doors to global career opportunities.
          </p>

          <div className="pro-hero-btn-wrapper">
            <button className="pro-btn-enroll" onClick={() => navigate("/contact")}>
            Start Your Global Journey Today
            </button>
          </div>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="col-lg-5 col-md-12 pro-hero-img-col position-relative d-flex justify-content-end align-items-end">
          {/* 1. Background Pattern */}
        {/*   <img
            src="https://school.madhiacademy.com/wp-content/uploads/sites/2/2025/09/Asset-05-copy.png"
            alt="Pattern"
            className="pro-hero-pattern"
          /> */}

          {/* 2. Main Image */}
          <img
            src={hero}
            alt="Professional Working"
            className="pro-hero-main-img"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
